<template>
  <b-row class="pr-lg-4">
    <b-col cols="12" class="mb-5">
      <PageTitle title="Criar banner" />
    </b-col>
    <b-col cols="12" class="form-group">
      <label class="font-weight-bold">
        Banner *
        <b-button
          v-if="fields.image"
          size="sm"
          variant="danger"
          class="ml-2"
          @click="removeImage()"
        >
          <i class="fas fa-trash"></i>
        </b-button>
      </label>
      <div v-if="fields.image">
        <b-img :src="`${getImagesAddressApp}${fields.image}`" fluid></b-img>
      </div>
      <b-form-file
        v-else
        accept="image/*"
        browse-text="Selecionar"
        placeholder="Insira uma imagem de 1920px de largura por 500px de altura"
        v-model="imageSelected"
        @input="addImage()"
      ></b-form-file>
      <error-message :errorMessage="requiredFields.image" />
    </b-col>
    <b-col cols="6" class="form-group">
      <label class="font-weight-bold">URL (Opcional)</label>
      <input
        type="text"
        class="form-control"
        id="video"
        v-model="fields.url"
        placeholder="Link para qual o usuário será redirecionado ao clicar no banner (Ex: https://youtube.com...)"
      />
    </b-col>
    <b-col cols="3" class="form-group">
      <label class="font-weight-bold">Ordernação do banner</label>
      <input
        type="number"
        class="form-control"
        id="order"
        v-model="fields.order"
        placeholder="xx"
      />
    </b-col>
    <b-col cols="3" class="form-group">
      <label class="font-weight-bold">Abrir em nova guia</label><br>
      <input type="radio" name="newTab" value="1" v-model="fields.newTab">
      <label class="ml-1 mr-2">Sim</label>
      <input type="radio" name="newTab" value="0" v-model="fields.newTab">
      <label class="ml-1">Não</label>
    </b-col>
    <b-col cols="12" md="3" class="form-group">
      <label class="font-weight-bold">Tipos de usuários</label>
      <b-form-checkbox
        switch
        v-model="selectedUserTypes.client"
        @change="addUserType(USER_TYPES.CLIENT)"
      >
        Cliente
      </b-form-checkbox>
      <b-form-checkbox
        switch
        v-model="selectedUserTypes.professional"
        @change="addUserType(USER_TYPES.PROFESSIONAL)"
      >
        Profissional
      </b-form-checkbox>
      <b-form-checkbox
        switch
        v-model="selectedUserTypes.shopkeeper"
        @change="addUserType(USER_TYPES.SHOPKEEPER)"
      >
        Empresa
      </b-form-checkbox>
      <b-form-checkbox
        switch
        v-model="selectAll"
        @change="addUserType('all')"
      >
        Todos
      </b-form-checkbox>
      <error-message :errorMessage="requiredFields.userTypes" />
    </b-col>
    <b-col cols="12" md="3" class="form-group">
      <label class="font-weight-bold">Plataformas</label>
      <b-form-checkbox
        switch
        v-model="selectedBannerPlatforms.app"
        @change="addPlatformsType(BANNER_PLATFORMS.APP)"
      >
        Aplicativo
      </b-form-checkbox>
      <b-form-checkbox
        switch
        v-model="selectedBannerPlatforms.web"
        @change="addPlatformsType(BANNER_PLATFORMS.WEB)"
      >
        Web/Site
      </b-form-checkbox>
      <b-form-checkbox
        switch
        v-model="selectedBannerPlatforms.all"
        @change="addPlatformsType(BANNER_PLATFORMS.ALL)"
      >
        Todos
      </b-form-checkbox>
      <error-message :errorMessage="requiredFields.platforms" />
    </b-col>
    <b-col cols="12" class="mb-2">
      <b-button 
        variant="danger" 
        @click="redirect()"
      > 
        <i class="fas fa-arrow-left mr-2"></i>
        Voltar
      </b-button>

      <b-button variant="success" @click="save()" class="ml-3">
        <i class="fas fa-save mr-2"></i>
        Salvar
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';

import makeToast from 'Mixins/makeToast';
import ErrorMessage from 'Components/ErrorMessage.vue';
import UserTypes from '@/enums/UserTypes';

import USER_TYPES from 'Enums/UserTypes.js';
import BANNER_PLATFORMS from '@/enums/BannerPlatforms.js';

export default {
  name: 'CustomizationSaveBanner',
  mixins: [makeToast],
  components: { PageTitle, ErrorMessage },
  data() {
    return {
      BANNER_PLATFORMS,
      USER_TYPES,
      imageSelected: null,
      selectAll: null,
      /** Objeto utilizado para controlar o estado dos checkboxes somente nesse componente */
      selectedUserTypes: {
        client: null,
        professional: null,
        shopkeeper: null,
      },
      selectedBannerPlatforms: {
        all: null,
        app: null,
        web:null,
      },
      fields: {
        id: '',
        image: '',
        url: '',
        order: null,
        userTypes: [],
        platform:'',
        newTab:1
      },
      requiredFields: {},
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
  },
  mounted() {
    const { id } = this.$route.params;
    this.fields.id = id || '';

    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', ['saveBanner', 'getBanner']),
    ...mapActions('files', ['uploadFileApiApp', 'deleteFile']),
    get() {
      if (!this.fields.id) return;

      this.$store.dispatch('startLoader');

      this.getBanner(this.fields.id)
        .then((response) => {
          const { image, url, order, userTypes, platforms, newTab } = response.data.data;
          this.fields.image = image || '';
          this.fields.url = url || '';
          this.fields.order = order || null;
          this.fields.newTab = newTab == true ? 1 : 0;
          this.fields.platform = platforms[0] ? platforms[0].platform : BANNER_PLATFORMS.ALL;
          this.handleUserTypes(userTypes);
          this.handlePlatformsType(this.fields.platform);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer o banner',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    redirect() {
      this.$router.push({ name: 'lojista-customizacoes-banners' });
    },
    save() {
      if(this.selectedBannerPlatforms.all){
        this.fields.platform = BANNER_PLATFORMS.ALL;
      }else if(this.selectedBannerPlatforms.app){
        this.fields.platform = BANNER_PLATFORMS.APP;
      }else {
        this.fields.platform = BANNER_PLATFORMS.WEB;
      }

      if(!this.fields.platform){
        this.errorMessages.platform = "Campo obrigatório'"
        return;
      }

      if(this.fields.userTypes.includes('all')) {
        this.fields.userTypes = [];
        this.fields.userTypes.push(1);
        this.fields.userTypes.push(2);
        this.fields.userTypes.push(3);
      }
      const request = {
        userId: this.userTypeId(),
        ...this.fields,
      };

      this.$store.dispatch('startLoader');
      this.saveBanner(request)
        .then((response) => {
          const { id } = response.data.data || {};
          this.fields.id = id;
          this.makeToast('Sucesso', 'Banner adicionado com sucesso');
          this.$router.push({ name: this.typeRouteById() });
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          if(this.requiredFields.image) return
          if(this.requiredFields.userTypes) return
        });
    },
    typeRouteById(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? 'balconista-customizacoes-banners' : 'lojista-customizacoes-banners';
    },
    addPlatformsType(value){
      switch (parseInt(value) ) {
        case BANNER_PLATFORMS.ALL:
          if(this.selectedBannerPlatforms.all){
            this.selectedBannerPlatforms.app = true;
            this.selectedBannerPlatforms.web = true;
          } 
          else {
            this.selectedBannerPlatforms.app = !this.selectedBannerPlatforms.app;
            this.selectedBannerPlatforms.web = !this.selectedBannerPlatforms.web;
          }
          break;
        case BANNER_PLATFORMS.APP:
          if(this.selectedBannerPlatforms.web && this.selectedBannerPlatforms.app) {
            this.selectedBannerPlatforms.all = true
          } else {
            this.selectedBannerPlatforms.all = false
          }
          break
        case BANNER_PLATFORMS.WEB:
          if(this.selectedBannerPlatforms.web && this.selectedBannerPlatforms.app) {
            this.selectedBannerPlatforms.all = true
          } else {
            this.selectedBannerPlatforms.all = false
          }
          break;
        default:
          break;
      }
      this.requiredFields.typePlatforms = "";
    },
    addUserType(userType) {
      if(userType == 'all') {
        this.typeUserSelect(true);
      }

      if(userType == 'all'  && !this.selectAll)
        this.typeUserSelect(true)

      if(this.selectedUserTypes.client == true &&
        this.selectedUserTypes.professional == true &&
        this.selectedUserTypes.shopkeeper == true 
      ){
        this.selectAll = true;
      }else {
        this.selectAll = false;
      }

      this.requiredFields.userTypes = '';

      if (this.fields.userTypes.includes(userType)) {
        
        if(userType == 'all') {
          this.fields.userTypes = [];
          this.typeUserSelect(false);
          return
        } else {
          const index = this.fields.userTypes.indexOf(userType);
          this.fields.userTypes.splice(index, 1);

          if(this.selectedUserTypes.client == false &&
            this.selectedUserTypes.professional == false &&
            this.selectedUserTypes.shopkeeper == false 
          ){
            this.selectAll = false;
          }
        }
        return;
      }
      this.fields.userTypes.push(userType);
    },
    typeUserSelect(value){
      this.selectedUserTypes.client = value;
      this.selectedUserTypes.professional = value;
      this.selectedUserTypes.shopkeeper = value;
      this.selectAll = value;
    },
    handlePlatformsType(platform){
      if(!platform) return;
      if(platform === BANNER_PLATFORMS.ALL) {
        this.selectedBannerPlatforms.all = true;
        this.selectedBannerPlatforms.web = true;
        this.selectedBannerPlatforms.app = true;
      }
      if(platform === BANNER_PLATFORMS.WEB) this.selectedBannerPlatforms.web = true;
      if(platform === BANNER_PLATFORMS.APP) this.selectedBannerPlatforms.app = true;
    },
    handleUserTypes(userTypes) {
      if (!userTypes || !userTypes.length) return;

      userTypes.forEach((type) => {
        const intType = type.user_type;
        this.fields.userTypes.push(intType);
        if (intType === USER_TYPES.CLIENT) this.selectedUserTypes.client = true;

        if (intType === USER_TYPES.PROFESSIONAL) this.selectedUserTypes.professional = true;

        if (intType === USER_TYPES.SHOPKEEPER) this.selectedUserTypes.shopkeeper = true;
      });

      if(this.selectedUserTypes.client && 
        this.selectedUserTypes.professional && 
        this.selectedUserTypes.shopkeeper) this.selectAll = true;
    },
    addImage() {
      if (!this.imageSelected) return;

      this.requiredFields.image = '';

      const formData = new FormData();
      formData.append('file', this.imageSelected);
      formData.append('validImg', 'validImg');

      this.$store.dispatch('startLoader');

      this.uploadFileApiApp(formData)
        .then((response) => {
          if(response.data.error && response.data.error == true) {
            this.makeToast('Opss!', response.data.message, 'danger');
          } else {
            this.fields.image = response.data.data;
            this.makeToast('Sucesso!', 'Imagem inserida com sucesso!', 'success');
          }
        })
        .catch(() => {
          this.fields.image = '';

          this.makeToast(
            'Oops!',
            'Não foi possível inserir sua imagem, tente novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.imageSelected = null;
          this.$store.dispatch('endLoader');
        });
    },
    removeImage() {
      if (!this.fields.image) return;

      const fileName = this.fields.image;
      this.fields.image = '';

      this.deleteFile(fileName).then().catch().finally();
    },
    handleErrorMessages(errorMessages) {
      if (!errorMessages) return;

      Object.keys(errorMessages).forEach((key) => {
        this.$set(this.requiredFields, key, 'Campo obrigatório');
      });
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
  },
};
</script>